import { StProperty } from '@/types'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

interface ConfirmationModalProps {
  isOpen: boolean
  selectedStaysProperty: StProperty | null
  setSelectedStaysProperty: React.Dispatch<
    React.SetStateAction<StProperty | null>
  >
  onClose: () => void
}

export const ConfirmationModal = ({
  isOpen,
  setSelectedStaysProperty,
  onClose,
}: ConfirmationModalProps) => {
  const navigate = useNavigate()
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={'xl'}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>COMO DESEJA PROCEDER?</ModalHeader>
        <ModalBody>
          <Text>Vamos criar a primeira acomodação na nova propriedade?</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            w="full"
            variant="outline"
            color={'gray.500'}
            onClick={() => {
              setSelectedStaysProperty(null)
              onClose()
              navigate('/properties')
              return
            }}
          >
            Não, voltar a listagem
          </Button>
          <Button
            w="full"
            colorScheme="blue"
            onClick={() => {
              onClose()
              navigate('/properties/new')
            }}
          >
            Adicionar 1ª acomodação
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
